module.exports = __webpack_public_path__ + "static/gatsbyTemplate-12bf71c6565cdfbdfc7c41a4ba88c6e3.png";